import { useEffect, useState } from 'react'

/** A value that settles: it follows `value` once `ms` have passed without a change. For search boxes. */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms)
    return () => clearTimeout(timer)
  }, [value, ms])
  return settled
}
